import { useEffect } from "react";
import { Route, Routes, useSearchParams } from "react-router";
import { AdminView } from "@/features/admin";
import { LoginPage } from "@/features/auth";
import { StudioView } from "@/features/studio";

export default function App() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const referral = searchParams.get("referral");
    if (referral) {
      localStorage.setItem("referral_code", referral);
    }
  }, [searchParams]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/admin" element={<AdminView />} />
      <Route path="/:projectId?" element={<StudioView />} />
    </Routes>
  );
}
